(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dhajia-property-editorial"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    var dialog=root.querySelector('[data-dps-dialog]'),slides=Array.from(root.querySelectorAll('[data-dps-slide]')),index=0,opener=null;
    var labels=JSON.parse(root.querySelector('[data-dps-translations]').textContent);
    var track=root.querySelector('[data-dps-track]'),photos=Array.from(root.querySelectorAll('.dps__gallery [data-dps-open]')),thumbs=Array.from(root.querySelectorAll('[data-dps-thumb]')),active=0;
    var previous=root.querySelector('[data-dps-gallery-prev]'),next=root.querySelector('[data-dps-gallery-next]'),expand=root.querySelector('[data-dps-expand]');
    var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    function updateGallery(n){
      active=n;
      root.querySelector('[data-dps-gallery-count]').textContent=(active+1)+' '+labels.of+' '+photos.length;
      thumbs.forEach(function(thumb,i){if(i===active)thumb.setAttribute('aria-current','true');else thumb.removeAttribute('aria-current');});
      if(previous)previous.disabled=active===0;
      if(next)next.disabled=active===photos.length-1;
    }
    function move(n,instant){
      var target=Math.max(0,Math.min(photos.length-1,n));
      if(!photos[target])return;
      var x=track.scrollLeft+photos[target].getBoundingClientRect().left-track.getBoundingClientRect().left;
      track.scrollTo({left:x,behavior:instant||reduced.matches?'instant':'smooth'});
      updateGallery(target);
    }
    if(track&&photos.length){
      updateGallery(0);
      if(previous){previous.hidden=false;next.hidden=false;previous.addEventListener('click',function(){move(active-1);});next.addEventListener('click',function(){move(active+1);});}
      thumbs.forEach(function(thumb,i){thumb.addEventListener('click',function(event){event.preventDefault();move(i);});});
      var settleTimer;
      track.addEventListener('scroll',function(){clearTimeout(settleTimer);settleTimer=setTimeout(function(){var box=track.getBoundingClientRect(),nearest=0,distance=Infinity;photos.forEach(function(photo,i){var d=Math.abs(photo.getBoundingClientRect().left-box.left);if(d<distance){nearest=i;distance=d;}});updateGallery(nearest);},140);},{passive:true});
      track.addEventListener('keydown',function(event){if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();move(active+(event.key==='ArrowRight'?1:-1));}if(event.key==='Home'){event.preventDefault();move(0);}if(event.key==='End'){event.preventDefault();move(photos.length-1);}});
    }
    function show(n){
      index=(n+slides.length)%slides.length;
      slides.forEach(function(slide,i){slide.hidden=i!==index;if((i===index||i===(index+1)%slides.length)&&!slide.getAttribute('src'))slide.src=slide.dataset.src;});
      root.querySelector('[data-dps-counter]').textContent=(index+1)+' '+labels.of+' '+slides.length;
    }
    if(dialog&&typeof dialog.showModal==='function'&&slides.length){
      function openPhoto(control,n){opener=control;show(n);dialog.showModal();document.documentElement.classList.add('dps-dialog-open');}
      photos.forEach(function(control){control.addEventListener('click',function(event){event.preventDefault();openPhoto(control,Number(control.dataset.dpsOpen));});});
      expand.hidden=false;expand.addEventListener('click',function(){openPhoto(expand,active);});
      root.querySelector('[data-dps-close]').addEventListener('click',function(){dialog.close();});
      root.querySelector('[data-dps-prev]').addEventListener('click',function(){show(index-1);});
      root.querySelector('[data-dps-next]').addEventListener('click',function(){show(index+1);});
      dialog.addEventListener('keydown',function(event){if(event.key==='ArrowLeft'){event.preventDefault();show(index-1);}if(event.key==='ArrowRight'){event.preventDefault();show(index+1);}});
      dialog.addEventListener('click',function(event){if(event.target===dialog)dialog.close();});
      dialog.addEventListener('close',function(){document.documentElement.classList.remove('dps-dialog-open');move(index,true);if(opener)opener.focus({preventScroll:true});});
      if(slides.length===1){root.querySelector('[data-dps-prev]').hidden=true;root.querySelector('[data-dps-next]').hidden=true;}
      var startX=0,startY=0;
      dialog.addEventListener('touchstart',function(event){if(event.touches.length!==1)return;startX=event.changedTouches[0].clientX;startY=event.changedTouches[0].clientY;},{passive:true});
      dialog.addEventListener('touchend',function(event){var dx=event.changedTouches[0].clientX-startX,dy=event.changedTouches[0].clientY-startY;if(Math.abs(dx)>65&&Math.abs(dx)>Math.abs(dy)*1.4)show(index+(dx<0?1:-1));},{passive:true});
    }
    var share=root.querySelector('[data-dps-share]');
    if(navigator.clipboard&&share){share.hidden=false;share.addEventListener('click',function(){var link=document.querySelector('link[rel="canonical"]');navigator.clipboard.writeText(link?link.href:location.href).then(function(){root.querySelector('[data-dps-share-status]').textContent=labels.copied;}).catch(function(){root.querySelector('[data-dps-share-status]').textContent=labels.failed;});});}
  }
  function initAll(scope){if(scope.matches&&scope.matches('[data-dps]'))init(scope);scope.querySelectorAll('[data-dps]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document);},{once:true});else initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dhajia-property-sale-collection"]) return;
  try {
    
(function () {
  function normalizePropertyText(value) {
    return String(value || '').replace(/[łŁ]/g, 'l').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9\u0600-\u06ff]+/g, ' ').trim();
  }

  function propertyMatches(card, filters) {
    var data = card.dataset;
    if (filters.type && data.propertyType !== filters.type) return false;
    if (filters.location && normalizePropertyText(data.propertyLocation) !== filters.location) return false;
    if (filters.beds && (!data.propertyBeds || Number(data.propertyBeds) < filters.beds)) return false;
    var price = Number(data.propertyPrice) / 100;
    if ((filters.minimum !== null || filters.maximum !== null) && price <= 0) return false;
    if (filters.minimum !== null && (!Number.isFinite(price) || price < filters.minimum)) return false;
    if (filters.maximum !== null && (!Number.isFinite(price) || price > filters.maximum)) return false;
    var search = normalizePropertyText(data.propertySearch);
    return filters.terms.every(function (term) { return search.indexOf(term) !== -1; });
  }

  function initializePropertySearch(root) {
    if (root.dataset.propertyReady) return;
    var form = root.querySelector('[data-property-form]');
    var translations = root.querySelector('[data-property-translations]');
    if (!form || !translations) return;
    var text = JSON.parse(translations.textContent);
    var query = form.querySelector('[data-property-query]');
    var type = form.querySelector('[data-property-type-select]');
    var location = form.querySelector('[data-property-location-select]');
    var minimum = form.querySelector('[data-property-min]');
    var maximum = form.querySelector('[data-property-max]');
    var beds = form.querySelector('[data-property-beds-select]');
    var sort = root.querySelector('[data-property-sort]');
    var chips = root.querySelector('[data-property-chips]');
    var controls = [query, type, location, minimum, maximum, beds];
    var initialOrder = new Map();
    var clear = form.querySelector('[data-property-clear]');
    var budgetError = form.querySelector('[data-property-budget-error]');
    var count = root.querySelector('[data-property-count]');
    var scope = root.querySelector('[data-property-scope]');
    var empty = root.querySelector('[data-property-empty]');
    var loadButton = root.querySelector('[data-property-load]');
    var pagination = root.querySelector('[data-property-pagination]');
    var cards = Array.from(root.querySelectorAll('[data-property-card]'));
    var loadedIds = new Set(cards.map(function (card) { return card.dataset.propertyId; }));
    var totalPages = Math.max(1, Number(root.dataset.pages) || 1);
    var loadedPages = new Set([Number(root.dataset.page) || 1]);
    var loading = false;
    var failed = false;
    var active = false;
    var inputTimer;
    root.dataset.propertyReady = 'true';
    form.hidden = false;
    root.querySelector('[data-property-sort-wrap]').hidden = false;

    function message(key, amount) {
      return text[key].replace('__COUNT__', String(amount)).replace('__TOTAL__', root.dataset.total);
    }

    function addLocations() {
      var known = new Set(Array.from(location.options).map(function (option) { return option.value; }));
      cards.forEach(function (card) {
        var value = normalizePropertyText(card.dataset.propertyLocation);
        if (!value || known.has(value)) return;
        var option = document.createElement('option');
        option.value = value;
        option.textContent = card.dataset.propertyLocation;
        location.appendChild(option);
        known.add(value);
      });
      Array.from(location.options).slice(1).sort(function(a,b) { return a.textContent.localeCompare(b.textContent); }).forEach(function(option) { location.appendChild(option); });
    }

    function readFilters() {
      var lower = minimum.value === '' ? null : Number(minimum.value);
      var upper = maximum.value === '' ? null : Number(maximum.value);
      var invalid = minimum.validity.badInput || maximum.validity.badInput || (lower !== null && (!Number.isFinite(lower) || lower < 0)) || (upper !== null && (!Number.isFinite(upper) || upper < 0)) || (lower !== null && upper !== null && lower > upper);
      budgetError.hidden = !invalid;
      minimum.setAttribute('aria-invalid', String(invalid));
      maximum.setAttribute('aria-invalid', String(invalid));
      return {
        type: type.value,
        location: location.value,
        beds: Number(beds.value) || 0,
        minimum: invalid ? null : lower,
        maximum: invalid ? null : upper,
        terms: normalizePropertyText(query.value).split(' ').filter(Boolean)
      };
    }

    function render() {
      var filters = readFilters();
      active = Boolean(type.value || location.value || beds.value || minimum.value || maximum.value || query.value.trim());
      clear.hidden = !active;
      var visibleCount = 0;
      cards.forEach(function (card) {
        var visible = propertyMatches(card, filters) && (root.dataset.savedOnly !== 'true' || card.dataset.buyerSaved === 'true');
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });
      cards.forEach(function(card, index) { if (!initialOrder.has(card.dataset.propertyId)) initialOrder.set(card.dataset.propertyId, index); });
      var ordered = cards.slice().sort(function(a, b) {
        if (sort.value === 'newest') return Number(b.dataset.propertyDate) - Number(a.dataset.propertyDate);
        if (sort.value.indexOf('price-') === 0) {
          var ap = Number(a.dataset.propertyPrice), bp = Number(b.dataset.propertyPrice);
          if (!ap || !bp) return !ap && !bp ? 0 : !ap ? 1 : -1;
          return sort.value === 'price-asc' ? ap - bp : bp - ap;
        }
        return initialOrder.get(a.dataset.propertyId) - initialOrder.get(b.dataset.propertyId);
      });
      var grid = root.querySelector('[data-property-grid]');
      ordered.forEach(function(card) { grid.appendChild(card); });
      chips.replaceChildren();
      controls.forEach(function(control) {
        if (!control.value.trim()) return;
        var chip = document.createElement('button');
        chip.type = 'button';
        var label = form.querySelector('label[for="' + control.id + '"]').textContent;
        var value = control.tagName === 'SELECT' ? control.selectedOptions[0].textContent : control.value;
        chip.textContent = label + ': ' + value + ' ×';
        chip.setAttribute('aria-label', text.remove + ' ' + label + ': ' + value);
        chip.addEventListener('click', function() { control.value = ''; update(); control.focus({preventScroll:true}); });
        chips.appendChild(chip);
      });
      var complete = loadedPages.size >= totalPages;
      count.textContent = message('results', visibleCount);
      scope.hidden = complete;
      scope.textContent = loading ? text.loading + ' ' + message('scope', cards.length) : (failed ? text.failed + ' ' : '') + message('scope', cards.length);
      empty.hidden = visibleCount !== 0;
      empty.textContent = complete ? text.empty : text.empty_partial;
      loadButton.hidden = complete;
      loadButton.disabled = loading;
      loadButton.textContent = loading ? text.loading : text.load_more;
      if (pagination) pagination.hidden = complete;
    }

    async function loadRemainingPages() {
      if (loading || loadedPages.size >= totalPages) return;
      loading = true;
      failed = false;
      render();
      var requests = 0;
      try {
        for (var page = 1; page <= totalPages && requests < 10; page += 1) {
          if (loadedPages.has(page)) continue;
          requests += 1;
          var url = new URL(root.dataset.collectionUrl, window.location.origin);
          var current = new URL(window.location.href);
          current.searchParams.forEach(function (value, key) {
            if (key !== 'page' && key !== 'section_id' && key !== 'sections') url.searchParams.set(key, value);
          });
          url.searchParams.set('page', String(page));
          url.searchParams.set('section_id', root.dataset.sectionId);
          if (url.origin !== window.location.origin) throw new Error('Invalid collection origin');
          var controller = new AbortController();
          var timeout = window.setTimeout(function () { controller.abort(); }, 12000);
          var response;
          try {
            response = await fetch(url.toString(), { credentials: 'same-origin', signal: controller.signal });
            if (!response.ok) throw new Error('Property page unavailable');
            var html = await response.text();
          } finally {
            window.clearTimeout(timeout);
          }
          var documentPage = new DOMParser().parseFromString(html, 'text/html');
          var section = documentPage.querySelector('[data-property-collection]');
          if (!section || section.dataset.sectionId !== root.dataset.sectionId || Number(section.dataset.page) !== page) throw new Error('Invalid property page');
          var additions = Array.from(section.querySelectorAll('[data-property-card]'));
          additions.forEach(function (card) {
            var id = card.dataset.propertyId;
            var category = card.dataset.propertyCategory;
            if (!id || loadedIds.has(id)) return;
            root.querySelector('[data-property-grid]').appendChild(card);
            cards.push(card);
            loadedIds.add(id);
          });
          loadedPages.add(page);
          addLocations();
          render();
        }
      } catch (error) {
        failed = true;
      } finally {
        loading = false;
        render();
      }
    }

    function saveUrl() {
      var url = new URL(window.location.href);
      controls.forEach(function(control) { if (control.value) url.searchParams.set(control.name, control.value); else url.searchParams.delete(control.name); });
      if (sort.value !== 'featured') url.searchParams.set('property_sort', sort.value); else url.searchParams.delete('property_sort');
      window.history.replaceState(null, '', url);
    }
    function restoreUrl() {
      var params = new URL(window.location.href).searchParams;
      var requestedLocation = params.get(location.name);
      if (requestedLocation && !Array.from(location.options).some(function(option) { return option.value === requestedLocation; })) {
        var option = document.createElement('option');
        option.value = requestedLocation;
        option.textContent = requestedLocation;
        location.appendChild(option);
      }
      controls.forEach(function(control) { control.value = params.get(control.name) || ''; });
      sort.value = params.get('property_sort') || 'featured';
      if (!sort.value) sort.value = 'featured';
    }
    function update() {
      saveUrl();
      render();
      if ((active || sort.value !== 'featured') && !failed) loadRemainingPages();
    }

    root.addEventListener('buyer:filter', update);
    root.addEventListener('buyer:saved', render);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      window.clearTimeout(inputTimer);
      update();
    });
    form.addEventListener('input', function (event) {
      if (event.target.tagName === 'SELECT') return;
      window.clearTimeout(inputTimer);
      inputTimer = window.setTimeout(update, 180);
    });
    form.addEventListener('change', function () {
      window.clearTimeout(inputTimer);
      update();
    });
    form.addEventListener('reset', function () {
      window.clearTimeout(inputTimer);
      window.setTimeout(function () {
        sort.value = 'featured';
        update();
        query.focus({ preventScroll: true });
      }, 0);
    });
    loadButton.addEventListener('click', loadRemainingPages);
    sort.addEventListener('change', update);
    addLocations();
    restoreUrl();
    update();
    loadRemainingPages();
    window.addEventListener('popstate', function() { restoreUrl(); render(); if (active || sort.value !== 'featured') loadRemainingPages(); });
  }

  function initializeAll(scope) {
    if (scope.matches && scope.matches('[data-property-collection]')) initializePropertySearch(scope);
    scope.querySelectorAll('[data-property-collection]').forEach(initializePropertySearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); }, { once: true });
  } else {
    initializeAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dhajia-property-sold"]) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    var dialog=root.querySelector('[data-dps-dialog]'),slides=Array.from(root.querySelectorAll('[data-dps-slide]')),index=0,opener=null;
    var labels=JSON.parse(root.querySelector('[data-dps-translations]').textContent);
    var track=root.querySelector('[data-dps-track]'),photos=Array.from(root.querySelectorAll('.dps__gallery [data-dps-open]')),thumbs=Array.from(root.querySelectorAll('[data-dps-thumb]')),active=0;
    var previous=root.querySelector('[data-dps-gallery-prev]'),next=root.querySelector('[data-dps-gallery-next]'),expand=root.querySelector('[data-dps-expand]');
    var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    function updateGallery(n){
      active=n;
      root.querySelector('[data-dps-gallery-count]').textContent=(active+1)+' '+labels.of+' '+photos.length;
      thumbs.forEach(function(thumb,i){if(i===active)thumb.setAttribute('aria-current','true');else thumb.removeAttribute('aria-current');});
      if(previous)previous.disabled=active===0;
      if(next)next.disabled=active===photos.length-1;
    }
    function move(n,instant){
      var target=Math.max(0,Math.min(photos.length-1,n));
      if(!photos[target])return;
      var x=track.scrollLeft+photos[target].getBoundingClientRect().left-track.getBoundingClientRect().left;
      track.scrollTo({left:x,behavior:instant||reduced.matches?'instant':'smooth'});
      updateGallery(target);
    }
    if(track&&photos.length){
      updateGallery(0);
      if(previous){previous.hidden=false;next.hidden=false;previous.addEventListener('click',function(){move(active-1);});next.addEventListener('click',function(){move(active+1);});}
      thumbs.forEach(function(thumb,i){thumb.addEventListener('click',function(event){event.preventDefault();move(i);});});
      var settleTimer;
      track.addEventListener('scroll',function(){clearTimeout(settleTimer);settleTimer=setTimeout(function(){var box=track.getBoundingClientRect(),nearest=0,distance=Infinity;photos.forEach(function(photo,i){var d=Math.abs(photo.getBoundingClientRect().left-box.left);if(d<distance){nearest=i;distance=d;}});updateGallery(nearest);},140);},{passive:true});
      track.addEventListener('keydown',function(event){if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();move(active+(event.key==='ArrowRight'?1:-1));}if(event.key==='Home'){event.preventDefault();move(0);}if(event.key==='End'){event.preventDefault();move(photos.length-1);}});
    }
    function show(n){
      index=(n+slides.length)%slides.length;
      slides.forEach(function(slide,i){slide.hidden=i!==index;if((i===index||i===(index+1)%slides.length)&&!slide.getAttribute('src'))slide.src=slide.dataset.src;});
      root.querySelector('[data-dps-counter]').textContent=(index+1)+' '+labels.of+' '+slides.length;
    }
    if(dialog&&typeof dialog.showModal==='function'&&slides.length){
      function openPhoto(control,n){opener=control;show(n);dialog.showModal();document.documentElement.classList.add('dps-dialog-open');}
      photos.forEach(function(control){control.addEventListener('click',function(event){event.preventDefault();openPhoto(control,Number(control.dataset.dpsOpen));});});
      expand.hidden=false;expand.addEventListener('click',function(){openPhoto(expand,active);});
      root.querySelector('[data-dps-close]').addEventListener('click',function(){dialog.close();});
      root.querySelector('[data-dps-prev]').addEventListener('click',function(){show(index-1);});
      root.querySelector('[data-dps-next]').addEventListener('click',function(){show(index+1);});
      dialog.addEventListener('keydown',function(event){if(event.key==='ArrowLeft'){event.preventDefault();show(index-1);}if(event.key==='ArrowRight'){event.preventDefault();show(index+1);}});
      dialog.addEventListener('click',function(event){if(event.target===dialog)dialog.close();});
      dialog.addEventListener('close',function(){document.documentElement.classList.remove('dps-dialog-open');move(index,true);if(opener)opener.focus({preventScroll:true});});
      if(slides.length===1){root.querySelector('[data-dps-prev]').hidden=true;root.querySelector('[data-dps-next]').hidden=true;}
      var startX=0,startY=0;
      dialog.addEventListener('touchstart',function(event){if(event.touches.length!==1)return;startX=event.changedTouches[0].clientX;startY=event.changedTouches[0].clientY;},{passive:true});
      dialog.addEventListener('touchend',function(event){var dx=event.changedTouches[0].clientX-startX,dy=event.changedTouches[0].clientY-startY;if(Math.abs(dx)>65&&Math.abs(dx)>Math.abs(dy)*1.4)show(index+(dx<0?1:-1));},{passive:true});
    }
    var share=root.querySelector('[data-dps-share]');
    if(navigator.clipboard&&share){share.hidden=false;share.addEventListener('click',function(){var link=document.querySelector('link[rel="canonical"]');navigator.clipboard.writeText(link?link.href:location.href).then(function(){root.querySelector('[data-dps-share-status]').textContent=labels.copied;}).catch(function(){root.querySelector('[data-dps-share-status]').textContent=labels.failed;});});}
  }
  function initAll(scope){if(scope.matches&&scope.matches('[data-dps]'))init(scope);scope.querySelectorAll('[data-dps]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document);},{once:true});else initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header');
			this.headerWrapper = document.querySelector('.header-wrapper');
			this.headerIsAlwaysSticky =
				this.getAttribute('data-sticky-type') === 'always';
			this.currentScrollTop = 0;
			this.preventReveal = false;
			this.predictiveSearch = this.querySelector('predictive-search');

			this.headerCoords = {};
			this.calcHeaderCoords();

			this.onScrollHandler = this.onScroll.bind(this);
			this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.addEventListener('scroll', this.onScrollHandler, false);
		}

		disconnectedCallback() {
			this.removeEventListener(
				'preventHeaderReveal',
				this.hideHeaderOnScrollUp,
			);
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		calcHeaderCoords() {
			const clientRect = this.getBoundingClientRect();
			const pageYOffset =
				window.pageYOffset || document.documentElement.scrollTop;
			this.headerCoords.bottom = pageYOffset + clientRect.bottom;
			this.headerCoords.top = pageYOffset + clientRect.top;
		}

		onScroll() {
			const scrollTop =
				window.pageYOffset || document.documentElement.scrollTop;

			if (this.headerIsAlwaysSticky) {
				if (this.header.classList.contains('color-background-overlay')) {
					if (scrollTop > this.header.offsetHeight + 1) {
						this.header.classList.remove('color-background-overlay');
						this.header.classList.add(
							'color-background-overlay-hidden',
							'shopify-section-header-sticky',
						);
					}
				}

				if (this.header.classList.contains('color-background-overlay-hidden')) {
					if (scrollTop < this.header.offsetHeight) {
						this.header.classList.add('color-background-overlay');
						this.header.classList.remove(
							'color-background-overlay-hidden',
							'shopify-section-header-sticky',
						);
					}
				}
			}

			if (
				scrollTop > this.currentScrollTop &&
				scrollTop > this.headerCoords.bottom
			) {
				if (this.preventHide) return;
				requestAnimationFrame(this.hide.bind(this));
			} else if (
				scrollTop < this.currentScrollTop &&
				scrollTop > this.headerCoords.bottom
			) {
				if (!this.preventReveal) {
					requestAnimationFrame(this.reveal.bind(this));
				} else {
					window.clearTimeout(this.isScrolling);

					this.isScrolling = setTimeout(() => {
						this.preventReveal = false;
					}, 66);

					requestAnimationFrame(this.hide.bind(this));
				}
			} else if (scrollTop <= this.headerCoords.top) {
				requestAnimationFrame(this.reset.bind(this));
			}

			this.currentScrollTop = scrollTop;
		}

		hide() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add(
				'shopify-section-header-hidden',
				'shopify-section-header-sticky',
			);
			this.closeMenuDisclosure();
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');

			if (this.header.classList.contains('color-background-overlay')) {
				this.header.classList.remove('color-background-overlay');
				this.header.classList.add('color-background-overlay-hidden');
			}
		}

		reset() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.remove(
				'shopify-section-header-hidden',
				'shopify-section-header-sticky',
				'animate',
			);

			if (this.header.classList.contains('color-background-overlay-hidden')) {
				this.header.classList.add('color-background-overlay');
				this.header.classList.remove('color-background-overlay-hidden');
			}
		}

		closeMenuDisclosure() {
			this.disclosures =
				this.disclosures || this.header.querySelectorAll('details-disclosure');
			if (typeof DetailsDisclosure !== 'undefined') {
				this.disclosures.forEach(disclosure => {
					disclosure.close();
				});
			}
			this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			this.disclosureLists.forEach(disclosureList => {
				disclosureList.setAttribute('hidden', true);
			});
		}
	}

	customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();
			this.spinnerIcon = this.querySelector('.cart__note-loading');
			this.successIcon = this.querySelector('.cart__note-success');
			this.textarea = this.querySelector('textarea');
			this.cartButtons = document.querySelector('.cart__ctas');

			this.textarea.addEventListener(
				'input',
				debounce((event) => {
					this.spinnerIcon.style.display = 'block';
					this.successIcon.style.display = 'none';
					this.cartButtons.style.pointerEvents = 'none';
					this.cartButtons.style.opacity = '0.7';

					const body = JSON.stringify({ note: event.target.value });

					fetch(`${routes.cart_update_url}`, {
						...fetchConfig(),
						...{ body },
					})
						.then((response) => {
							if (!response.ok) {
								throw new Error('Network response was not ok');
							}
							return response.json();
						})
						.then((data) => {
							this.successIcon.style.display = 'block';

							setTimeout(() => {
								this.successIcon.style.display = 'none';
							}, 2000);
						})
						.catch((error) => {
							console.error(
								'There was a problem with the fetch operation:',
								error,
							);
						})
						.finally(() => {
							this.spinnerIcon.style.display = 'none';
							this.cartButtons.removeAttribute('style');
						});
				}, 300),
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
